import React, { useContext } from 'react';

import { NCRContext } from 'views';

import { StatusArrow } from 'components/layout';

const ReturnStatusArrows = () => {
  const { state } = useContext(NCRContext);

  return (
    <>
      {state.ncr.status.id !== 7 ? (
        <>
          <StatusArrow name="Draft" active={state.ncr.status.id === 1} />
          <StatusArrow
            name="Pending Approval"
            active={state.ncr.status.id === 2}
          />
          <StatusArrow name="Approved" active={state.ncr.status.id === 3} />
          <StatusArrow
            name="Return Pending"
            active={state.ncr.status.id === 8}
          />
          <StatusArrow name="Closed" active={state.ncr.status.id === 6} />
        </>
      ) : (
        <>
          <StatusArrow name="Cancelled" active />
        </>
      )}
    </>
  );
};

export { ReturnStatusArrows };
